import * as React from "react";
import NavBar from "../../components/NavBar";
import {Box, CircularProgress, Divider, FormControl, FormControlLabel, Radio, RadioGroup} from "@mui/material";
import {Height} from '@mui/icons-material';
import {addCommas, convertPrice, removeNonNumeric, useShowMessageComponent} from "../../assets/js/main";
import {useTranslation} from "react-i18next";
import {setLoading} from "../../redux/loading/actions";
import {useDispatch, useSelector} from "react-redux";
import HandleFetchData from "../../plugin/HandleFetchData";
import {createSearchParams, useLocation, useNavigate, useSearchParams} from "react-router-dom";

export default function Index() {
    const {t} = useTranslation()
    const {fetchData} = HandleFetchData()
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const {showMessageComponent} = useShowMessageComponent()
    const location = useLocation();


    const dispatch = useDispatch();
    const selector = useSelector((st) => st)
    const tokenStorage = localStorage.getItem('token')
    const [validations, setValidations] = React.useState(null);
    const [contents, setContents] = React.useState('');
    const [price, setPrice] = React.useState('');
    const [weight, setWeight] = React.useState('');
    const [size, setSize] = React.useState('');
    const [width, setWidth] = React.useState('');
    const [height, setHeight] = React.useState('');
    const [length, setLength] = React.useState('');
    const [boxNo, setBoxNo] = React.useState('');
    const [factor, setFactor] = React.useState('');
    const [listBoxSize, setListBoxSize] = React.useState([]);
    const [listBoxNo, setListBoxNo] = React.useState([]);
    const [shipmentItems, setShipmentItems] = React.useState(null);
    const [payMethods, setPayMethods] = React.useState([]);
    const [itemsInvoices, setItemsInvoices] = React.useState(null);
    const [paymentMethod, setPaymentMethod] = React.useState("Payments.Wallet");
    const divarIncomId = searchParams.get('state') || localStorage.getItem('token-id')


    React.useEffect(() => {
        getBoxSize()
        getInfoOrder()
    }, [])


    // متد دریافت لیست سایز جعبه ها
    const getBoxSize = async () => {
        dispatch(setLoading(true))
        let fetch = await fetchData('', 'GET', '/StandardBoxSize', '', "text/html", '', '', '')
        if (fetch?.message === "Network Error" && !tokenStorage) {
            // enqueueSnackbar(t("error.t1"), {
            //   variant: 'error',
            //   TransitionProps: {
            //     direction: 'down',
            //   },
            //   anchorOrigin: {
            //     horizontal: 'center',
            //     vertical: 'top'
            //   }
            // })
        }
        setListBoxSize(fetch?.Data)
        dispatch(setLoading(false))
    }
    const getInfoOrder = async () => {
        dispatch(setLoading(true))
        let fetch = await fetchData('', 'GET', '/shipmentsInfo', '', "text/html", {
            ShipmentId: searchParams.get('no')
        }, '', '')
        if (fetch?.message === "Network Error" && !tokenStorage) {
            // enqueueSnackbar(t("error.t1"), {
            //   variant: 'error',
            //   TransitionProps: {
            //     direction: 'down',
            //   },
            //   anchorOrigin: {
            //     horizontal: 'center',
            //     vertical: 'top'
            //   }
            // })
        }
        setContents(fetch?.data?.ContentType)
        setPrice(fetch?.data?.ApproximateValue)
        setSize(fetch?.data?.CartonSizeName)
        setWeight(fetch?.data?.Weight)
        setWidth(fetch?.data?.width)
        setHeight(fetch?.data?.height)
        setLength(fetch?.data?.length)
        setFactor(fetch?.data?.HasAccessToPrinter ? '1' : '0')
        setShipmentItems(fetch?.data)
        // setListBoxSize(fetch?.Data)
        dispatch(setLoading(false))
    }


    const editOrder = async () =>  {
        dispatch(setLoading(true))
        let fetch = await fetchData('', 'PUT', '/EditOrder', {
            "ShipmentId": Number(searchParams.get('no')),
            "ContentType": contents,
            "ApproximateValue": Number(String(price)?.split(',').join('')) || "",
            "Weight": Number(String(weight)?.split(',').join('')) || "",
            "HasAccessToPrinter": shipmentItems?.HasAccessToPrinter,
            "length": length,
            "width": width,
            "height": height,
            "CartonSizeName": size,
            "AccessPrinterValue": shipmentItems?.AccessPrinterValue,
            "PrintLogoValue": shipmentItems?.PrintLogoValue,
            "NeedCollector": shipmentItems?.NeedCollector,
            "NeedDistributer": shipmentItems?.NeedDistributer
        }, "application/json", '', '', '')
        if(!fetch?.success){
            await showMessageComponent(fetch?.message, 'warning')
        }else if(!fetch?.paiedByWallet){
            await getPaymentMethods(fetch?.orderId)
            setItemsInvoices(fetch)
        }else{
            await showMessageComponent(t("msg.t5"), 'success')
            setTimeout(() => {
                navigate({
                    pathname: "/orderList",
                    search: location?.search.split('&')[0]
                });
            }, 500)

        }

        // payOrder(fetch?.orderId)
        dispatch(setLoading(false))
    }

    const getPaymentMethods = async (id) => {
        let fetch = await fetchData('', 'GET', '/getPaymentMethod', '',
            "application/json", {
                "orderId": String(id),
                "paymentMethodForId": "1"
            }, '', ''
        )
        if (fetch?.Data) {
            setPayMethods(fetch?.Data)
        }else{
            await showMessageComponent(fetch?.Message, 'warning')
        }
    }

    const payOrder = async (id) => {
        dispatch(setLoading(true))
        let fetch = await fetchData('', 'POST', '/payment', {
                "orderId": Number(itemsInvoices?.orderId),
                "paymentmethod": paymentMethod === "Payments.Wallet" ? "" : paymentMethod,
                "useRewardPoints": paymentMethod === "Payments.Wallet",
                "isForeign": false,
                "reciverPay": false,
                "DivarToken": divarIncomId || null,
                "callBackUrl": `https://${process.env.REACT_APP_SUBDOMAIN}.postex.ir/paymentStatus`
            },
            "application/json", '', '', ''
        )
        if (fetch?.IsSuccess) {
            if (paymentMethod === "Payments.Wallet") {
                navigate({
                    pathname: "/paymentStatus",
                    search: fetch?.Data?.divarToken ? createSearchParams({
                            OrderId: fetch?.Data?.orderId,
                            code: 0,
                            state: fetch?.Data?.divarToken
                        }).toString() :
                        createSearchParams({
                            OrderId: fetch?.Data?.orderId,
                            code: 0,
                        }).toString()
                });
                showMessageComponent(fetch?.Message, 'success')
            } else {
                window.open(fetch?.Data, '_self')
            }
        } else if (fetch && fetch?.StatusCode == 500) {
            navigate({
                pathname: "/pageInternalServer",
                search: location?.search
            });
        } else {
            showMessageComponent(fetch?.Message, 'error')
        }
        dispatch(setLoading(false))
    }

    return (
        <>
            <NavBar blue back/>

            <div className="container">
                <div className="packingPage desktopSection">
                    <div className="row">
                        <div className="col-12 col-lg-4">
                            <div className="info-box">
                                <h5>{t("packing.t1")}</h5>

                                <p>{t("packing.t2")}: {shipmentItems?.ContentType}</p>
                                <p>{t("packing.t3")}: {convertPrice(shipmentItems?.ApproximateValue)} {t("packing.t4")}</p>
                                <p>{t("packing.t5")}: {convertPrice(shipmentItems?.Weight)} {t("packing.t6")}</p>
                                <p>{t("packing.t7")}: {shipmentItems?.CartonSizeName}</p>
                                {/*<p>{t("packing.t8")}: 3</p>*/}
                            </div>

                            <div className="info-box">
                                <h5>{t("packing.t9")}</h5>
                                <p>{t("packing.t10")}: {shipmentItems?.ReceiverFirstName + ' ' + shipmentItems?.ReceiverLastName}</p>
                                <p>{t("packing.t11")}: {shipmentItems?.ReceiverPhoneNumber}</p>
                                <p>{t("packing.t12")}: {shipmentItems?.ReceiverAddress}</p>
                                <p>{t("packing.t13")}: {shipmentItems?.CategoryName}</p>
                                <p>{t("packing.t14")}: {shipmentItems?.NeedCollector ? 'دارد' : 'ندارد'}</p>
                                <p>{t("packing.t15")}: {shipmentItems?.AccessPrinterValue} ({convertPrice(shipmentItems?.AccessPrinterPrice)} {t("packing.t4")})</p>
                                <p>{t("packing.t16")}: {shipmentItems?.PrintLogoValue} {shipmentItems?.PrintLogoPrice ? (convertPrice(shipmentItems?.PrintLogoPrice) + '' + t("packing.t4")) : null}</p>
                            </div>

                        </div>
                        <div className="col-12 col-lg-8">
                            <h5>{t("packing.t17")}</h5>

                            <div className="addItem">
                                <div className="row">
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <label className="required">{t("packing.t18")}</label>
                                        <input type="text" name="contents" value={contents}
                                               onChange={(e) => setContents(e.target.value)}/>

                                        {
                                            validations?.contents_validation &&
                                            <p className="error">{validations?.contents_validation}</p>
                                        }
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <label className="required">{t("packing.t19")}</label>
                                        <input type="text" name="price" value={convertPrice(price)}
                                               onChange={(e) => setPrice(addCommas(removeNonNumeric(e.target.value)))}/>

                                        {
                                            validations?.price_validation &&
                                            <p className="error">{validations?.price_validation}</p>
                                        }
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <label className="required">{t("packing.t20")}</label>
                                        <input type="text" name="weight" value={weight}
                                               onChange={(e) => setWeight(addCommas(removeNonNumeric(e.target.value)))}/>

                                        {
                                            validations?.weight_validation &&
                                            <p className="error">{validations?.weight_validation}</p>
                                        }
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <label className="required">{t("packing.t21")}</label>
                                        <select aria-label="Default select example"
                                                onChange={(e) => {
                                                    setSize(
                                                        // e?.target?.value === 'سایز بزرگتراز 9' ?
                                                        //     e?.target?.value
                                                        //     :
                                                            listBoxSize?.find(x => x?.Id.toString() === e?.target?.value.toString())?.Name
                                                    )
                                                    setLength(
                                                        listBoxSize?.find(x => x?.Id.toString() === e?.target?.value.toString())?.Length
                                                    )
                                                    setWidth(
                                                        listBoxSize?.find(x => x?.Id.toString() === e?.target?.value.toString())?.Width
                                                    )
                                                    setHeight(
                                                        listBoxSize?.find(x => x?.Id.toString() === e?.target?.value.toString())?.Height
                                                    )
                                                }}>
                                            <option value="" selected disabled>{size || t("homeDesktop.s1.t4.tt10")}</option>
                                            {
                                                listBoxSize?.map((item, index) => <option key={item?.Id}
                                                                                          value={item?.Id}>{item?.Name}</option>)
                                            }

                                            {/*<option value="سایز بزرگتراز 9">{t("homeDesktop.s1.t4.tt22")}</option>*/}

                                        </select>

                                        {
                                            size === 'سایر(بزرگتر از کارتن سایز 9)' &&
                                            <div className="row">
                                                <div className="col-4">
                                                    <input type="number" min="1" name="length"
                                                           onChange={(e) => setLength(e?.target?.value)}
                                                           placeholder={t("multiOrder.s2.t7") + '' + '(cm)'}
                                                           value={length || ""}/>
                                                </div>
                                                <div className="col-4">
                                                    <input type="number" min="1" name="width"
                                                           onChange={(e) => setWidth(e?.target?.value)}
                                                           placeholder={t("multiOrder.s2.t8") + '' + '(cm)'}
                                                           value={width || ""}/>
                                                </div>
                                                <div className="col-4">
                                                    <input type="number" min="1" name="height"
                                                           onChange={(e) => setHeight(e?.target?.value)}
                                                           placeholder={t("multiOrder.s2.t9") + '' + '(cm)'}
                                                           value={height || ""}/>
                                                </div>
                                            </div>
                                        }

                                        {/*<p>{t("packing.t25")}: {convertPrice(47000)} {t("packing.t4")}</p>*/}

                                        <div className="viewSize">
                                            <div className="sizeBox">
                                                <div className="length">
                                                    <div>
                                                        <Height/>
                                                        <span>{length}Cm</span>
                                                    </div>
                                                    <p>{t("packing.t29")}</p>
                                                </div>
                                                <div className="width">
                                                    <div>
                                                        <Height/>
                                                        <span>{width}Cm</span>
                                                    </div>
                                                    <p>{t("packing.t30")}</p>
                                                </div>

                                                <div className="height">
                                                    <div>
                                                        <Height/>
                                                        <span>{height}Cm</span>
                                                    </div>
                                                    <p>{t("packing.t31")}</p>
                                                </div>
                                            </div>
                                        </div>


                                        {
                                            validations?.size_validation &&
                                            <p className="error">{validations?.size_validation}</p>
                                        }
                                    </div>
                                    {/*<div className="col-12 col-md-6 col-lg-4">*/}
                                    {/*  <label className="required">{t("packing.t22")}</label>*/}
                                    {/*  <select aria-label="Default select example" value={boxNo}*/}
                                    {/*          onChange={(e) => setBoxNo(e?.target?.value)}>*/}
                                    {/*    <option value="" selected disabled>{t("homeDesktop.s1.t4.tt10")}</option>*/}
                                    {/*    {*/}
                                    {/*      listBoxNo?.map((item, index) => <option key={item?.Id} value={item.Id}>{item.Name}</option>)*/}
                                    {/*    }*/}

                                    {/*  </select>*/}

                                    {/*  {*/}
                                    {/*    validations?.boxNo_validation &&*/}
                                    {/*    <p className="error">{validations?.boxNo_validation}</p>*/}
                                    {/*  }*/}
                                    {/*</div>*/}
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <label className="required">{t("packing.t23")}</label>
                                        <select aria-label="Default select example" value={factor}
                                                onChange={(e) => setFactor(e?.target?.value)}>
                                            <option value="" selected disabled>{t("homeDesktop.s1.t4.tt10")}</option>
                                            <option value="0">{t("packing.t28")}</option>
                                            <option value="1">{t("packing.t27")}</option>
                                        </select>

                                        {
                                            validations?.factor_validation &&
                                            <p className="error">{validations?.factor_validation}</p>
                                        }


                                        {/*<div className="btnGroup_blue">*/}
                                        {/*  <button className="btnFill">*/}
                                        {/*    {t("packing.t24")}*/}
                                        {/*    <Add/>*/}
                                        {/*  </button>*/}
                                        {/*</div>*/}
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>


                    <Divider/>


                    {itemsInvoices &&
                        <FormControl>
                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={paymentMethod}
                                onChange={(event) => setPaymentMethod(event.target.value)}
                                id="paymentMethod"
                            >
                                {
                                    payMethods?.PaymentMethods?.map((item, index) =>
                                        item?.Name !== "بانک سامان" &&
                                        <FormControlLabel value={item?.PaymentMethodSystemName} control={<Radio/>}
                                                          label={item?.Name + ' ' + `${item?.PaymentMethodSystemName === "Payments.Wallet"
                                                              ? `( ${(payMethods?.RewardPointsBalance ?
                                                                  convertPrice(payMethods?.RewardPointsBalance) : 0) + ' ' + t("singleOrder.invoice.t14")} )` : ''}`}/>
                                    )
                                }
                            </RadioGroup>
                        </FormControl>
                    }


                    {!itemsInvoices ?
                        <div className="_btnGroup_yellow">
                            <button className="btnFill" onClick={editOrder}>
                                {
                                    selector?.loading?.isLoading ?
                                        <Box sx={{display: 'flex'}}>
                                            <CircularProgress size={20}/>
                                        </Box>
                                        :
                                        <span>{t("packing.t26")}</span>
                                }
                            </button>
                        </div>
                        :
                        <div className="_btnGroup_yellow">
                            <button className="btnFill" onClick={payOrder}>
                                {
                                    selector?.loading?.isLoading ?
                                        <Box sx={{display: 'flex'}}>
                                            <CircularProgress size={20}/>
                                        </Box>
                                        :
                                        <span>{t("singleOrder.t4")}</span>
                                }
                            </button>
                        </div>}
                </div>
            </div>

        </>
    )
}
